import { render, staticRenderFns } from "./DefaultSidebar.vue?vue&type=template&id=539e4bac&scoped=true"
import script from "./DefaultSidebar.vue?vue&type=script&lang=js"
export * from "./DefaultSidebar.vue?vue&type=script&lang=js"
import style0 from "./DefaultSidebar.vue?vue&type=style&index=0&id=539e4bac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539e4bac",
  null
  
)

export default component.exports